import { action, observable } from "mobx"

export default class UiStore {
  @observable
  redirectUrlAfterAuth = `${process.env.INFRA_INTERN_URL}/auth/register`
  @observable authPromptModalOpen: boolean = false
  @observable courseSchduleSelectModalOpen: boolean = false
  @observable confirmCourseApplyModalOpen: boolean = false
  @observable completeApplyCourseModalOpen: boolean = false
  @observable completeRegistrationModalOpen: boolean = false
  @observable completeApplyConsultationModalOpen: boolean = false
  @observable needRegistrationModalOpen: boolean = false

  @action
  toggleAuthPromptModal = (redirectUrl?: string): void => {
    this.authPromptModalOpen = !this.authPromptModalOpen
    if (redirectUrl) {
      this.redirectUrlAfterAuth = redirectUrl
    }
  }

  toggleCourseSchduleSelectModal = (): void => {
    this.courseSchduleSelectModalOpen = !this.courseSchduleSelectModalOpen
  }

  toggleConfirmCourseApplyModal = (): void => {
    this.confirmCourseApplyModalOpen = !this.confirmCourseApplyModalOpen
  }

  toggleCompleteApplyCourseModal = (): void => {
    this.completeApplyCourseModalOpen = !this.completeApplyCourseModalOpen
  }

  toggleCompleteRegistrationModal = (): void => {
    this.completeRegistrationModalOpen = !this.completeRegistrationModalOpen
  }

  toggleApplyConsultationModal = (): void => {
    this.completeApplyConsultationModalOpen = !this.completeApplyConsultationModalOpen
  }

  toggleRegistrationModal = (): void => {
    this.needRegistrationModalOpen = !this.needRegistrationModalOpen
  }
}
